import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form, Select } from 'antd';

import styled from 'styled-components/macro';
import FormLabel from 'components/FormLabel/FormLabel';

const FormItem = Form.Item;

const selectionStyle = { width: '100%', fontSize: '14px' };

const addRules = (requiredErrorMessage, extraRules = []) => {
  const rules = [];
  if (requiredErrorMessage && typeof requiredErrorMessage === 'string') {
    rules.push({
      required: true,
      message: requiredErrorMessage
    });
  }
  return [...rules, ...extraRules];
};

const FormSelection = ({
  className,
  allowClear,
  defaultValue,
  extraRules,
  form,
  formLabel,
  label,
  name,
  multipleMode,
  onChange,
  onSearch,
  placeholder,
  requiredErrorMessage,
  shouldDisable,
  selections,
  size
}) => {
  const rules = addRules(requiredErrorMessage, extraRules);
  const searchModeProps = onSearch
    ? {
        showSearch: true,
        defaultActiveFirstOption: false,
        onSearch
      }
    : {};
  return (
    <Fragment>
      {!formLabel && (
        <FormLabel size={size} className={className}>
          {label}
        </FormLabel>
      )}
      <FormItem label={formLabel} colon={false}>
        {form.getFieldDecorator(name, {
          rules: rules,
          initialValue: defaultValue
        })(
          <Select
            mode={multipleMode ? 'multiple' : 'default'}
            placeholder={placeholder}
            style={selectionStyle}
            size={size}
            disabled={shouldDisable}
            onChange={onChange}
            filterOption={true}
            optionFilterProp="children"
            {...searchModeProps}
            allowClear={allowClear}
          >
            {selections.map(selection => (
              <Select.Option key={selection.key} value={selection.key}>
                {selection.displayValue || selection.value}
              </Select.Option>
            ))}
          </Select>
        )}
      </FormItem>
    </Fragment>
  );
};

FormSelection.propTypes = {
  form: PropTypes.object.isRequired,
  formLabel: PropTypes.string,
  name: PropTypes.string.isRequired,
  selections: PropTypes.array.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  extraRules: PropTypes.array,
  label: PropTypes.string,
  multipleMode: PropTypes.bool,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  placeholder: PropTypes.string,
  requiredErrorMessage: PropTypes.string,
  shouldDisable: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'large']),
  allowClear: PropTypes.bool
};

FormSelection.defaultProps = {
  defaultValue: undefined,
  extraRules: [],
  form: {},
  label: '',
  multipleMode: false,
  onChange: () => {},
  onSearch: () => {},
  placeholder: '',
  shouldDisable: false,
  requiredErrorMessage: '',
  size: 'default',
  allowClear: false
};

export default styled(FormSelection)`
  margin-bottom: 0px;
`;

export class FormMultiSelectionReadOnly extends PureComponent {
  render() {
    const { label, selections, size } = this.props;
    return (
      <FormItem label={label} colon={false}>
        <Select mode="multiple" value={selections.map(selection => selection.key)} style={selectionStyle} size={size} disabled>
          {selections.map(selection => (
            <Select.Option key={selection.key} value={selection.key}>
              {selection.displayValue || selection.value}
            </Select.Option>
          ))}
        </Select>
      </FormItem>
    );
  }
}
